import OrganizationDisabled from './organizationDisabled';

export default OrganizationDisabled;
